/**
 * Base provider class that all AI providers extend
 */

import { AIProvider, ProviderConfig, ProviderType, UsageStats } from './types';

export abstract class BaseProvider implements AIProvider {
  protected config: ProviderConfig = {};
  protected initialized = false;

  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly type: ProviderType
  ) {}

  async initialize(config: ProviderConfig): Promise<void> {
    this.config = { ...this.config, ...config };
    await this.onInitialize();
    this.initialized = true;
  }

  async isAvailable(): Promise<boolean> {
    if (!this.initialized) {
      return false;
    }
    try {
      return await this.checkAvailability();
    } catch {
      return false;
    }
  }

  async getUsage(): Promise<UsageStats> {
    if (!this.initialized) {
      throw new Error(`Provider ${this.name} not initialized`);
    }
    return this.fetchUsage();
  }

  protected abstract onInitialize(): Promise<void>;
  protected abstract checkAvailability(): Promise<boolean>;
  protected abstract fetchUsage(): Promise<UsageStats>;

  protected ensureInitialized(): void {
    if (!this.initialized) {
      throw new Error(`Provider ${this.name} not initialized. Call initialize() first.`);
    }
  }
}
